"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurableListLoader = void 0;
const AnonymousClient_1 = require("@juvare/platform-sdk-js/AnonymousClient");
class ConfigurableListLoader {
    constructor(app, entity) {
        this.app = app;
        this.entity = entity;
        this.configurableListClient = new AnonymousClient_1.AnonymousClient(app, entity);
    }
    async loadDataList(name) {
        return this.configurableListClient
            .storageList({ filter: [{ column: 'name', op: '=', value: name }], limit: 1 })
            .then((response) => {
            if (response.total === 1) {
                return JSON.parse(response.rows[0].columns.value);
            }
            else {
                throw new Error('Configurable list ' + name + ' not found');
            }
        });
    }
    async loadDataLists(names) {
        return this.configurableListClient.storageList({ filter: [{ column: 'name', op: 'in', value: names }] }).then((response) => {
            if (response.total === names.length) {
                return response.rows.reduce((map, list) => {
                    map[list.columns.name] = JSON.parse(list.columns.value);
                    return map;
                }, {});
            }
            else {
                throw new Error('Configurable list ' +
                    names.filter((name) => !response.rows.find((row) => row.columns.name === name)).join(', ') +
                    ' not found');
            }
        });
    }
}
exports.ConfigurableListLoader = ConfigurableListLoader;
